import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogIn, X, ShoppingBag } from 'lucide-react';
import { Button } from './ui/button';
import './LoginPromptModal.css';

/**
 * LoginPromptModal - Simple modal to prompt users to login
 * Used when anonymous users try to perform actions that require auth
 */
function LoginPromptModal({ open, onClose, onLoginSuccess, message }) {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const isArabic = i18n.language?.startsWith('ar');
  const isRTL = document.dir === 'rtl' || isArabic;

  if (!open) return null;

  const handleLogin = () => {
    // Store return URL
    const returnUrl = window.location.hash.replace('#', '');
    localStorage.setItem('authReturnUrl', returnUrl);
    
    onClose();
    navigate('/auth');
  };

  const handleContinueBrowsing = () => {
    onClose();
  };

  return (
    <div 
      className="login-prompt-overlay" 
      onClick={onClose}
      data-testid="login-prompt-modal"
    >
      <div 
        className="login-prompt-content" 
        onClick={(e) => e.stopPropagation()}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        {/* Close button */}
        <button 
          className="login-prompt-close" 
          onClick={onClose}
          aria-label="Close"
        >
          <X size={20} />
        </button>
        
        {/* Icon */}
        <div className="login-prompt-icon">
          <LogIn size={32} />
        </div>
        
        {/* Message */}
        <h3 className="login-prompt-title">
          {isArabic ? 'سجّل الدخول للمتابعة' : 'Sign in to continue'}
        </h3>
        <p className="login-prompt-message">
          {message || (isArabic 
            ? 'يرجى تسجيل الدخول للوصول إلى هذه الميزة'
            : 'Please sign in to access this feature')}
        </p>
        
        {/* Actions */}
        <div className="login-prompt-actions">
          <Button
            onClick={handleLogin}
            className="login-btn"
            data-testid="login-prompt-signin"
          >
            <LogIn size={18} />
            {isArabic ? 'تسجيل الدخول' : 'Sign In'}
          </Button>
          
          <button
            onClick={handleContinueBrowsing}
            className="continue-btn"
            data-testid="login-prompt-continue"
          >
            <ShoppingBag size={18} />
            {isArabic ? 'متابعة التصفح' : 'Continue Browsing'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LoginPromptModal;
